import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { BarChart, Bar, ResponsiveContainer, LineChart, Line } from 'recharts';
import BuildIcon from '@mui/icons-material/Build';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TimerIcon from '@mui/icons-material/Timer';

const iconMap = {
  wrench: BuildIcon,
  warning: WarningAmberIcon,
  clock: AccessTimeIcon,
  refresh: AutorenewIcon,
  trending: TrendingUpIcon,
  timer: TimerIcon,
};

const KpiCard = ({ data }) => {
  const IconComponent = iconMap[data.icon] || BuildIcon;
  const chartData = data.sparkline
    ? data.sparkline.map((val, i) => ({ value: val }))
    : null;

  const isLineChart = data.id === 'oee';

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.8125rem' }}
          >
            {data.title}
          </Typography>
          <IconComponent sx={{ fontSize: 18, color: '#9CA3AF' }} />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 0.5 }}>
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, fontSize: '1.75rem', lineHeight: 1, color: 'text.primary' }}
              >
                {data.value}
              </Typography>
              {data.change && (
                <Typography
                  sx={{
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: data.changeType === 'positive' ? '#399432' : '#EF4444',
                  }}
                >
                  {data.change}
                </Typography>
              )}
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
              {data.subtitle}
            </Typography>
          </Box>

          {chartData && (
            <Box sx={{ width: 80, height: 40 }}>
              <ResponsiveContainer width="100%" height="100%">
                {isLineChart ? (
                  <LineChart data={chartData}>
                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke={data.sparkColor}
                      strokeWidth={2}
                      dot={false}
                    />
                  </LineChart>
                ) : (
                  <BarChart data={chartData}>
                    <Bar dataKey="value" fill={data.sparkColor} radius={[1, 1, 0, 0]} />
                  </BarChart>
                )}
              </ResponsiveContainer>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default KpiCard;
